module.exports = "/_next/static/images/so-5d09b7df27a913195743239076de0a76.svg";